var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "w-select",
    _vm._b(
      {
        staticClass: "f-collections",
        attrs: {
          value: _vm.items,
          "custom-label": function (option) {
            return option.name
          },
        },
        on: { input: _vm.updateItems },
      },
      "w-select",
      {
        label: _vm.label,
        single: _vm.single,
        readonly: _vm.readonly,
        options: _vm.options,
      },
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }